const pageName = { singular: 'Customer', plural: 'Customer' }

export default [
  {
    path: '/info-customer',
    name: 'info-customer',
    component: () => import('@/views/pages/komship/customer/InfoCustomer.vue'),
    meta: {
      name: pageName,
      routeDetail: 'detail-customer',
      navActiveLink: 'info-customer',
      resource: 'Customer',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/data-customer',
    name: 'data-customer',
    component: () => import('@/views/pages/komship/customer/DataCustomer.vue'),
    meta: {
      name: pageName,
      navActiveLink: 'data-customer',
      resource: 'Customer',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/grup-contact',
    name: 'grup-contact',
    component: () => import('@/views/pages/komship/customer/GrupKontak.vue'),
    meta: {
      name: pageName,
      navActiveLink: 'grup-contact',
      resource: 'Customer',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/grup-contact/:grup_id',
    name: 'grup-contact',
    component: () => import('@/views/pages/komship/customer/DaftarKontak.vue'),
    meta: {
      name: pageName,
      navActiveLink: 'grup-contact',
      resource: 'Customer',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
        {
          text: pageName.plural,
        },
      ],
    },
  },
  {
    path: '/grup-contact/:grup_id/create-contact',
    name: 'create-contact',
    component: () => import('@/views/pages/komship/customer/CreateNewContact.vue'),
    meta: {
      name: pageName,
      navActiveLink: 'grup-contact',
      resource: 'Customer',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
        {
          text: pageName.plural,
        },
      ],
    },
  },
  {
    path: '/import-from-komship',
    name: 'import-from-komship',
    component: () => import('@/views/pages/komship/customer/InputFromKomship.vue'),
    meta: {
      name: pageName,
      navActiveLink: 'grup-contact',
      resource: 'Customer',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
          active: true,
        },
      ],
    },
  },
  {
    path: '/info-customer/detail-customer/:customer_id',
    name: 'detail-customer',
    component: () => import('@/views/pages/komship/customer/DetailCustomer.vue'),
    meta: {
      name: pageName,
      navActiveLink: 'info-customer',
      routeDetailOrder: 'detail-order',
      resource: 'Customer',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
        },
        {
          text: 'Detail Customer',
          active: true,
        },
      ],
    },
  },
  {
    path: '/info-customer/detail-customer/detail-order/:order_id',
    name: 'detail-order',
    component: () => import('@/views/pages/komship/customer/DetailOrder.vue'),
    meta: {
      name: 'Detail Order',
      navActiveLink: 'info-customer',
      resource: 'Customer',
      action: 'manage',
      breadcrumb: [
        {
          text: pageName.plural,
        },
        {
          text: 'Detail order',
          active: true,
        },
      ],
    },
  },
]
